module.exports = __webpack_public_path__ + "img/four-onboarding-1.3db9fdb2.png";